
const FooterApp = () => {
  return (
    <div className="col-lg-3 col-md-3 col-12 footer_list text-center g-2">
      <div className='mb-2'>
        <h5>Get Event Planet Partner App</h5>
      <a href='https://apps.apple.com/in/app/ep-partner/id6758831340' className='mb-3'>
        <img src="/app-store.png" className='img-fruid' alt='Download From App Store'/>
      </a>
      <a href='https://play.google.com/store/apps/details?id=com.epvendor'>
        <img src="/play-store.png" className='img-fruid' alt='Download From Play Store'/>
      </a>
      </div>
    </div>
  )
}

export default FooterApp
